import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export function useIsMobile() {
  const [mobile, setMobile] = useState(false);
  useEffect(() => {
    // anteprima compatta solo su telefono: tablet e desktop mostrano tutto
    const mq = window.matchMedia("(max-width: 767px)");
    const upd = () => setMobile(mq.matches);
    upd();
    mq.addEventListener("change", upd);
    return () => mq.removeEventListener("change", upd);
  }, []);
  return mobile;
}

/* Su mobile la sezione mostra un'anteprima e questo tasto espande il resto */
export function ExpandPill({ open, onToggle, hiddenCount, testid, moreLabel }) {
  const { t } = useLang();
  return (
    <div className="mt-4 flex justify-center">
      <button
        type="button"
        data-testid={testid}
        onClick={onToggle}
        aria-expanded={open}
        className="group inline-flex items-center gap-2.5 rounded-full border border-sky-400/50 bg-sky-400/5 px-6 py-3 text-[10px] font-bold uppercase tracking-[0.18em] text-sky-300 transition-colors duration-300 hover:bg-sky-400 hover:text-[#090D14]"
      >
        {open ? t("news.showLess") : (moreLabel ?? t("common.showAllCount", { n: hiddenCount }))}
        <motion.span animate={{ rotate: open ? 180 : 0 }} transition={{ duration: 0.3 }}>
          <ChevronDown className="h-4 w-4" />
        </motion.span>
      </button>
    </div>
  );
}
